import { Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { pbxLocationsApi } from '~/apis/pbxLocationsApi'
import { useUserState } from '~/atoms/UserState'
import { toaster } from '~/components/ui/toaster'

import { PbxLocationsPage } from '@mangovoice/pbx-locations-ui'

export const PbxLocationsSettingsPage = () => {
  const { t } = useTranslation()
  const { pbxId } = useUserState({ canAutoRefresh: false })

  return (
    <Flex direction="column" flex={1} minH={0} p={6} overflowY="auto">
      <PbxLocationsPage
        api={pbxLocationsApi}
        pbxId={pbxId}
        toast={toaster}
        t={t}
      />
    </Flex>
  )
}
